export const CategorieItemSkeleton = () => {
    return (
        <div className="w-full h-28 overflow-hidden p-mini relative rounded-md z-0 animate-pulse bg-gray-100">
            <div className="h-20 w-20 rounded-tiny shadow-xl absolute bottom-[-20px] right-[-20px] rotate-6 z-2 bg-gray-200" />
            <div className="h-4 w-24 bg-gray-200 rounded absolute top-4 left-4 z-20" />
        </div>
    );
};